import { handleResponse, handleError, headerset } from "../apiUtils";

const baseUrl = (committente_id?: number) => {
  if (committente_id) {
    return (
      process.env.API_URL +
      "/api/anagrafiche/committenti/" +
      committente_id +
      "/"
    );
  } else {
    return process.env.API_URL + "/api/anagrafiche/committenti";
  }
};

export function fetchCommittenti() {
  return fetch(baseUrl(), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: headerset().Authorization,
    },
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getCommittente(committente_id: number) {
  let url = baseUrl(committente_id);
  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: headerset().Authorization,
    },
  })
    .then(handleResponse)
    .catch(handleError);
}
